import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import DialogActions from '@mui/material/DialogActions';

import { OPACITY_70 } from 'constants/opacity';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';
import { getHeaderAndNavigationTypography } from 'styles/helpers/getThemeStyles';
import { calculateRgbaWithAlpha } from 'helpers/colorFormatter';
import PrimaryCta from 'components/Buttons/PrimaryCta';
import SecondaryCta from 'components/Buttons/SecondaryCta';
import { StyledTypographyColorSectionNavLinkMain } from 'components/Cart/StyledTypographyColorSectionNavLinkMain';
import { selectCartGroupOrder } from 'bento-ordering/cart/selectors/index';
import {
  getGroupOrderJoinLeaveTitle,
  getGroupOrderJoinLeaveContinueLabel
} from 'bento-ordering/utils/groupOrder';

function GroupOrderJoinLeaveConfirmation({ toggleIsOpen, handleConfirm }) {
  const { admin_name: adminName = '' } = useSelector(selectCartGroupOrder);

  const leaveGroupOrderButtonStyles = theme => ({
    color: calculateRgbaWithAlpha(
      theme.palette?.button?.background?.hover,
      OPACITY_70
    ),
    ...getHeaderAndNavigationTypography(theme)
  });

  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      margin="20px 18px 75px"
    >
      <>
        <StyledTypographyColorSectionNavLinkMain
          textAlign="center"
          component="h4"
          variant={ITEM_DESCRIPTION_AND_PRICES}
        >
          {getGroupOrderJoinLeaveTitle(adminName)}
        </StyledTypographyColorSectionNavLinkMain>
        <DialogActions>
          <Box mt={2}>
            <PrimaryCta
              label={getGroupOrderJoinLeaveContinueLabel(adminName)}
              handleClick={toggleIsOpen}
              fullWidth
            />
          </Box>
          <Box mt={2}>
            <SecondaryCta
              label="Leave Group Order"
              handleClick={handleConfirm}
              fullWidth
              sx={leaveGroupOrderButtonStyles}
            />
          </Box>
        </DialogActions>
      </>
    </Box>
  );
}

GroupOrderJoinLeaveConfirmation.propTypes = {
  toggleIsOpen: PropTypes.func,
  handleConfirm: PropTypes.func
};

export default GroupOrderJoinLeaveConfirmation;
